import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './index.css'
import { registerIcons } from '@/plugins/registerIcons'
import './helpers/yupConfig'

export const app = createApp(App)

registerIcons(app)

app.use(router).mount('#app')

// register service worker
if ('serviceWorker' in navigator) {
    if (process.env.VUE_APP_MODE !== 'development') {
        navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`)
    }
}
